import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Geolocation } from '@capacitor/geolocation';
import { GoogleMap } from '@capacitor/google-maps';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import {
  AuthenticationStore,
  LocationData,
} from 'src/app/stores/authentication.store';
import { ShippingLocationStore } from 'src/app/stores/shippingLocation.store';
import { angolaProvince, googleMapApiKey } from 'src/environments/environment';
@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.scss'],
})
export class AddLocationComponent implements OnInit {
  // @ViewChild('map', { static: false }) mapRef: ElementRef;
  @ViewChild('map', { static: false })
  mapRef!: ElementRef;
  newMap!: GoogleMap;

  @Input() locationData: LocationData;
  @Input() type: number;
  @Input() pickUpAsStorage: boolean = false;
  @Input() customer: boolean = false;
  @Input() id: number;
  locationForm: FormGroup;
  validation_errors: any;
  latitude: number;
  longitude: number;
  showMap: boolean = false;
  coordinate: any;
  watchCoordinate: any;
  watchId: any;
  angolaProvince = angolaProvince;
  townList = [];
  marker: any;
  showSuggestions = false;
  geocodeResult: any;
  town: string;
  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private authenticationStore: AuthenticationStore,
    private modalCtrl: ModalController,
    private ship: ShippingLocationStore,
    private translate: TranslateService,
    private zone: NgZone
  ) {}

  async ngOnInit() {
    this.refreshForm();
    if (this.customer && this.id) {
      var resp: any = await this.ship.getLocationById(this.id);
      this.locationData = resp.data;
    }
    this.town = this.locationData.town;
  }

  onMarkerDragEnd() {
    const newPosition = this.marker.getPosition();
    this.getLatestPosition(newPosition.lat(), newPosition.lng());
  }

  getLatestPosition(lat: number, long: number) {
    const geocoder = new google.maps.Geocoder();
    var $this = this;
    geocoder.geocode(
      { location: { lat: lat, lng: long } },
      (results, status) => {
        if (status === 'OK') {
          if (results?.length > 0) {
            $this.town = results[0].formatted_address;
            $this.refreshForm();
            $this.latitude = lat;
            $this.longitude = long;
          } else {
            console.log('No results found');
          }
        } else {
          console.log('Geocoder failed due to: ' + status);
        }
      }
    );
  }

  async ionViewDidEnter() {
    this.refreshForm();
    if (this.customer && this.id) {
      var resp: any = await this.ship.getLocationById(this.id);
      this.locationData = resp.data;
      this.refreshForm();
      this.getLocationByAddress(this.town);
    } else {
      const coordinates = await Geolocation.getCurrentPosition();
      this.latitude = coordinates.coords.latitude;
      this.longitude = coordinates.coords.longitude;
      this.createMap();
    }
    this.town = this.locationData.town;
    this.getSellerLocation();
  }

  refreshForm() {
    this.locationForm = this.formBuilder.group({
      country: new FormControl('', Validators.compose([])),
      province: new FormControl('', Validators.compose([])),
      town: new FormControl(
        this.town,
        Validators.compose([Validators.required])
      ),
      street: new FormControl(''),
      building: new FormControl(''),
      house_no: new FormControl(''),
      pincode: new FormControl('', Validators.compose([])),
      area: new FormControl(''),
      type: new FormControl(
        !this.type ? 'storage_locations' : 'pickup_locations',
        Validators.compose([Validators.required])
      ),
      latitude: new FormControl(this.latitude ? this.latitude : ''),
      longitude: new FormControl(this.longitude ? this.longitude : ''),
    });
    if (this.locationData && this.locationData.province) {
      var filter = angolaProvince?.filter(
        (x) => x.name === this.locationData.province
      );
      this.townList = filter[0]?.municipos;
    }
    // this.getTown();
    this.getErrors();
  }

  getErrors() {
    this.validation_errors = {
      town: [{ type: 'required', message: 'INDIVIDUAL_SELLER.CITY_REQUIRED' }],
      pincode: [
        { type: 'required', message: 'INDIVIDUAL_SELLER.PINCODE_REQUIRED' },
      ],
    };
  }

  async saveLocation() {
    this.refreshForm();
    this.loaderService.showLoading();
    try {
      var resp: any;

      if (this.locationData && !this.pickUpAsStorage) {
        resp = await this.authenticationStore.updateLocation(
          this.customer,
          this.locationForm.value,
          this.id ? this.id : this.locationData.id
        );
      } else {
        resp = await this.authenticationStore.addLocation(
          this.customer,
          this.locationForm.value
        );
      }
      this.loaderService.dismissLoading();
      this.modalCtrl.dismiss(resp.data);
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data,
        'middle',
        'danger',
        5000
      );
    }
  }

  async dismissModal() {
    this.modalCtrl.dismiss();
  }

  getName() {
    if (this.type == 0) {
      return this.translate.instant('INDIVIDUAL_SELLER.STORE_LOCATION');
    } else if (this.type == 1) {
      return this.translate.instant('INDIVIDUAL_SELLER.PICKUP_LOCATION');
    } else {
      return this.translate.instant('INDIVIDUAL_SELLER.SHIPPING_LOCATION');
    }
  }

  getSellerLocation() {
    if (this.locationForm.value) {
      var value =
        'Casa N°' +
        (this.locationForm.value.house_no || '') +
        ' ' +
        'Rua N°' +
        (this.locationForm.value.street || '') +
        ',' +
        (this.locationForm.value.area || '') +
        ',' +
        (this.locationForm.value.building || '') +
        ',' +
        (this.locationForm.value.town || '') +
        ' ' +
        (this.locationForm.value.province || '') +
        ', ' +
        (this.locationForm.value.country || '') +
        ' ' +
        this.locationForm.value.pincode;
      value = value.replace(/null,/g, '');
      this.getLocationByAddress(value);

      this.showSuggestions = !!this.town;
    }
  }

  getTown(event: any) {
    var value = event.target.value;
    this.getLocationByAddress(value);

    this.showSuggestions = !!this.town;
  }

  selectSuggestion(selectedSuggestion: any) {
    this.town = selectedSuggestion.formatted_address;
    this.showSuggestions = false;
    this.getLocationByAddress(this.town);
  }

  getLocationByAddress(value) {
    var geocoder = new google.maps.Geocoder();
    var $this = this;
    geocoder.geocode(
      { address: value, componentRestrictions: { country: 'AO' } },
      function (results, status) {
        $this.geocodeResult = results;
        if (status == google.maps.GeocoderStatus.OK) {
          var lat = results[0].geometry.location.lat();
          var lang = results[0].geometry.location.lng();
          $this.latitude = lat;
          $this.longitude = lang;
          $this.locationForm.value.latitude = lat;
          $this.locationForm.value.longitude = lang;
          $this.createMap();

          // do something with the geocoded result
          //
          // results[0].geometry.location.latitude
          // results[0].geometry.location.longitude
        }
      }
    );
  }

  async createMap() {
    const element = document.getElementById('map');
    const map = new google.maps.Map(element, {
      center: { lat: this.latitude, lng: this.longitude },
      zoom: 11,
    });

    this.marker = new google.maps.Marker({
      position: { lat: this.latitude, lng: this.longitude },
      map: map,
      draggable: true,
    });

    this.marker.addListener('dragend', () => {
      this.onMarkerDragEnd();
    });
  }

  async onSelectPro(event) {
    this.townList = [];
    var filter = angolaProvince?.filter((x) => x.name === event.detail.value);
    this.townList = filter[0]?.municipos;
    // this.getTown();
  }

  onSelectTown() {
    // this.getTown();
  }
}
